import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';
import { morph } from '@theme/morph';

/**
 * Syncs the PDP product title when the selected variant changes.
 * Morphs from server-rendered HTML in the variant update response so Liquid
 * remains the single source of truth for brand strip and color suffix.
 *
 * @extends {Component}
 */
class ProductDisplayTitle extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newTitle = event.detail.data.html?.querySelector(
      `product-display-title[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newTitle) return;

    morph(this, newTitle, { childrenOnly: true });
  };
}

if (!customElements.get('product-display-title')) {
  customElements.define('product-display-title', ProductDisplayTitle);
}
